import { put, select } from 'redux-saga/effects';
import { getCookie, setCookie } from 'utils';
import { TTintService } from 'features/product-info/components/pdp-select-tint-color';
import { UPDATE_TINT_SERVICE_QUANTITY_FOR_ACTIVE_COLOR } from 'features/product-info/ducks/product-tint-service';
import { TINT_SERVICE_IDS } from 'features/product-info/components/pdp-select-tint-color/pdp-select-tint-color.const';
import { getDomainSelector } from 'common/selectors';
import { EffectR } from 'types/utils';
import { UpdateTintServiceInBasketPayload } from './actions';
import { getServicesWithoutTintServiceForActiveColor } from './helpers/get-services-without-tint-service-for-active-color';
import { getTintServicesFromCookies } from './helpers/get-tint-services-from-cookies';
import { getIsTintServiceWithSelectedColorInServices } from './helpers/get-is-tint-service-with-selected-color-in-services';
import { getServicesWithUpdatedQuantity } from './helpers/get-services-with-updated-quantity';
import { getServicesWithNewTintService } from './helpers/get-services-with-new-tint-service';
import log from 'loglevel';

export const COOKIE_KEY_FOR_SERVICES = 'servicesInfo';

export function* handleUpdateTintServiceInServiceBasket({
  payload,
}: {
  payload: UpdateTintServiceInBasketPayload;
}) {
  const { parentLineId, color, currentServiceQuantity, flowQty, hex, serviceIdForTint } = payload;

  const domain = (yield select(getDomainSelector)) as EffectR.Select<typeof getDomainSelector>;

  const serviceCookie = getCookie(COOKIE_KEY_FOR_SERVICES) || '';

  const newQuantityForSelectedColor = Number((currentServiceQuantity + flowQty).toFixed(2));

  try {
    const parsedServicesFromCookies =
      serviceCookie.length > 0 ? JSON.parse(decodeURIComponent(serviceCookie)) : [];
    const shouldDeleteServiceFromBasket = newQuantityForSelectedColor < 1;

    let updatedServices;

    if (shouldDeleteServiceFromBasket) {
      updatedServices = getServicesWithoutTintServiceForActiveColor({
        servicesFromCookie: parsedServicesFromCookies,
        color,
      });
    } else {
      const tintServicesForCurrentProductFromBasket = getTintServicesFromCookies({
        productCode: parentLineId,
        tintServiceIds: TINT_SERVICE_IDS,
        parsedServicesFromCookies,
      });

      const isTintServiceWithSelectedColorInServices = getIsTintServiceWithSelectedColorInServices({
        tintServices: tintServicesForCurrentProductFromBasket as TTintService[],
        color,
      });

      updatedServices = isTintServiceWithSelectedColorInServices
        ? getServicesWithUpdatedQuantity({
            selectedColor: color,
            hex,
            servicesFromCookies: parsedServicesFromCookies,
            newQuantity: newQuantityForSelectedColor,
          })
        : getServicesWithNewTintService({
            services: parsedServicesFromCookies,
            newTintService: { serviceIdForTint, hex, color, parentLineId },
            newQuantity: newQuantityForSelectedColor,
          });
    }

    setCookie(COOKIE_KEY_FOR_SERVICES, JSON.stringify(updatedServices), {
      expires: new Date(new Date().getFullYear() + 1, 12, 31),
      path: '/',
      domain,
    });

    yield put(UPDATE_TINT_SERVICE_QUANTITY_FOR_ACTIVE_COLOR(newQuantityForSelectedColor));
  } catch (err) {
    log.error('Saga handleUpdateTintServiceInServiceBasket error: ', err);
  }
}
